import React from "react";
import { motion } from "framer-motion";

import { slideUp } from "./utils";
import { SpringAnimationComponentProps } from "./types";

const SlideUp: React.FC<SpringAnimationComponentProps> = ({
  children,
  className,
  bounce = 0.15,
  duration = 0.5,
  delay = 0,
  ...props
}) => {
  return (
    <motion.div
      {...slideUp}
      {...props}
      className={className}
      transition={{ type: "spring", bounce, duration, delay }}
    >
      {children}
    </motion.div>
  );
};

export default SlideUp;
